import { render, staticRenderFns } from "./OrderPkgDialog.vue?vue&type=template&id=617b52b4&scoped=true&"
import script from "./OrderPkgDialog.vue?vue&type=script&lang=js&"
export * from "./OrderPkgDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderPkgDialog.vue?vue&type=style&index=0&id=617b52b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b52b4",
  null
  
)

export default component.exports